<template>
  <div class="envison-container">
    <img
      src="../../../public/resources/images/envision1.jpg"
      alt="image"
      class="uploaded-image"
    />
    <img
      src="../../../public/resources/images/envision2.jpg"
      alt="image"
      class="uploaded-image"
    />
    <img
      src="../../../public/resources/images/envision3.jpg"
      alt="image"
      class="uploaded-image"
    />
    <div v-for="(image, index) in images" :key="index">
      <img v-if="image" :src="image" alt="image" class="uploaded-image" />
    </div>
    <input
      type="file"
      ref="file"
      accept="image/jpeg/png"
      @change="uploadImage"
    />
    <button class="add-image-btn" @click="$refs.file.click()">
      <h3>Add</h3>
    </button>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "envison",
  data() {
    return {
      images: []
    };
  },
  props: {
    tool: {
      type: Object,
      required: false,
      default: () => {}
    },
    focus: {
      type: Object,
      required: false,
      default: () => {}
    },
    user: {
      type: Object,
      required: false,
      default: () => {}
    },
    typeaheadApps: {
      type: Array,
      default: () => ["Maps", "Calculator"]
    },
    idprop: {
      type: String
    },
    showTracking: {
      type: Boolean
    }
  },
  methods: {
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = e => {
        this.upload();
        this.images.push(e.target.result);
      };
    },
    async upload() {
      const db = firebase.firestore();
      const roomRef = await db
        .collection("users")
        .doc(this.$store.state.user.uid)
        .collection("focuses")
        .doc(this.focus.focusId);
      console.log(roomRef);
      //       var message = 'data:text/plain;base64,5b6p5Y+344GX44G+44GX44Gf77yB44GK44KB44Gn44Go44GG77yB';
      // roomRef.putString(message, 'data_url').then(function(snapshot) {
      //   console.log('Uploaded a data_url string!', snapshot);
      // });
    }
  }
};
</script>

<style lang="scss" scoped>
.envison-container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .uploaded-image {
    margin-left: 6px;
    margin-top: 6px;
    width: 90px;
    height: 90px;
    border-radius: 6px;
  }
  input {
    display: none;
  }
  .add-image-btn {
    border: none;
    margin-left: 6px;
    margin-top: 6px;
    width: 90px;
    height: 90px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
